export default {
  // 基础内容
  base: {
    ok: 'OK',
    done: 'Done',
    save: 'Save',
    saving: 'Saving',
    notice: 'Notice',
    successfully: 'Successfully',
    cancel: 'Cancel',
  },

  // 引导页
  guide: {
    manageMyProfile: 'Log In as Pet Owner',
    checkDogTagInfo: 'View Pet Info',
    languageSwitch: 'Language Switch',
    'Tag ID does not exist. ': 'Tag ID does not exist. ',
    'Please enter the dog tag ID.': 'Please enter the dog tag ID.',
    about: 'Dog Tag ID',
    info: [
      'This smart dog tag helps lost pets get back home.',
      '🐾 If you’ve found a dog wearing a PETHEY tag, tap “View Pet Info” and enter the Tag ID shown below the QR code to contact the owner.',
      '👤 If you’re a pet owner, tap “Log In as Pet Owner” to create and manage your dog’s profile.',
      'Enter the Tag ID below the QR code to view the pet’s info and contact its owner.'
    ],
    guideBtn: 'Operating Guide'
  },

  // 登录页
  login: {
    'Register': 'Register',
    'Log in to your': 'Log in to your',
    'Account': 'Account',
    'Please enter your email address': 'Please enter your email address',
    'Please enter your password': 'Please enter your password',
    'Enter code': 'Enter code',
    'Login with code': 'Login with code',
    'Please input email and password': 'Please input email and password',
    'Login with password': 'Login with password',
    'Please input email and code': 'Please input email and code',
    'Get code': 'Get code',
    'Please enter email address': 'Please enter email address',
    'Email sent successfully': 'Email sent successfully',
    'Email send failed': 'Email send failed',
    'Forget Password': 'Forget Password',
    'Log In': 'Log In',
    'Cannot connect to server': 'Cannot connect to server',
    'fetching user data error': 'fetching user data error',
    'Please agree to the agreement': 'Please agree to the agreement',
    'User Agreement': 'User Agreement',
    'User Agreement Content': 'User Agreement Content',
    'Privacy Agreement': 'Privacy Agreement',
    'Privacy Agreement Content': 'Consumer Business Privacy Statement\n' +
      'Introduction\n' +
      'The website and its global affiliates (collectively referred to as "the website," "we," or "our") value your privacy. We have developed this Privacy Statement (hereinafter referred to as "this Statement") to help you understand how we collect, use, disclose, protect, store, and transmit your personal data. Please read this Statement carefully and feel free to contact us if you have any questions.\n' +
      'This Statement applies to all website products and services that display or mention this Statement, including QR tags, software, toolkits, websites, and other services.\n' +
      'In addition, we recommend that you carefully read the Privacy Statement or supplementary notice related to specific products or services (hereinafter referred to as the "Product Privacy Notice"). The Product Privacy Notice is an integral part of this Statement and provides detailed descriptions on how each product or service processes your personal data. If any conflicts arise between this Statement and the Product Privacy Notice, the latter shall prevail.\n' +
      '\n' +
      '1. How the Website Collects Your Personal Data\n' +
      '1.1 Definition of Personal Data\n' +
      'Personal data refers to any information related to an identified or identifiable natural person, excluding anonymized data. When you use our products or services or interact with us, we may collect your personal data. The types of data collected will vary based on the specific service and your interactions with us. In certain cases, you may choose not to provide this data, but this may affect the normal use of certain services or result in us being unable to process your request.\n' +
      'We may also collect statistical data (such as visit frequency, code request frequency, and product quantities) to analyze how our products and services are used. Such statistical data is considered non-personal data. However, if non-personal data is mixed with personal data, we will treat the entire dataset as personal data.\n' +
      '\n' +
      '1.2 Types of Personal Data We May Collect\n' +
      '(1) Personal Data Provided by You\n' +
      '● Account Registration and Service Usage:When you register or log in to your website ID to add or delete tags or purchase services, we may collect your name, email address, mobile number, and other information.\n' +
      '\n' +
      '● Interaction and Sharing with Others:Some products allow you to communicate and share content with others. When using these features, you may need to create a public user profile that includes your nickname and avatar. We will also collect the contact information you provide (such as email addresses and phone numbers) to ensure communication security.\n' +
      '\n' +
      '● Identity Verification and Payment Requirements:To comply with local laws, such as those for real-name registration, anti-addiction systems, and online payments, we may need to collect government-issued identity proof or card information to verify your identity.\n' +
      '\n' +
      '(2) Data Collected Automatically During Service Use\n' +
      '● Device and Account Information: This includes device name, device identifier, activation time, hardware model, OS version, app version, region, and language settings.\n' +
      '● Log Information: Includes access time, access count, IP address, error and crash logs, and other log information.\n' +
      '● Location Information: When you scan a QR tag, we may collect location information from your device (via GPS). You may disable location permissions in your device settings.\n' +
      '\n' +
      '2. How We Use Your Personal Data\n' +
      'We will use your personal data based on legally permissible grounds. The purposes include, but are not limited to:\n' +
      '1. Registering and activating products or services you have purchased;\n' +
      '2. Providing a personalized user experience, with an option for you to decline personalization;\n' +
      '3. Sending marketing information or invitations to promotional events after obtaining your consent;\n' +
      '4. Conducting internal data analysis, business research, and auditing;\n' +
      '5. Improving our loss prevention and anti-fraud programs;\n' +
      '6. Displaying your contact information (such as phone number) when someone scans your QR tag.\n' +
      '\n' +
      '3. Cookies and Similar Technologies\n' +
      'We may use cookies, pixel tags, and local storage technologies to enhance your experience.\n' +
      '● Necessary Cookies: Help users log in and save preferences.\n' +
      '● Analytical Cookies: Used for statistical analysis of user behavior.\n' +
      '● Advertising Cookies: Provide personalized advertisements based on your interests.\n' +
      'You can manage or delete cookies through your browser, but disabling cookies may affect the functionality of certain services.\n' +
      '\n' +
      '4. How We Entrust, Share, Transfer, and Disclose Your Personal Data\n' +
      '4.1 Entrustment\n' +
      'We may entrust third parties to provide services such as customer support or technical support. These third parties can only process data under our supervision and in accordance with our instructions. They are required to implement confidentiality measures and must not retain this data after the entrustment contract ends.\n' +
      '4.2 Sharing\n' +
      'We will only share your data with third parties under the following circumstances:\n' +
      '1. With your consent, sharing with designated third parties;\n' +
      '2. When legally required, sharing with regulatory agencies;\n' +
      '3. Sharing with business partners: For instance, sharing order information with logistics companies for delivery purposes.\n' +
      '4.3 Data Transfer\n' +
      'In the event of company mergers, divisions, or bankruptcy involving data transfer, we will notify you in advance and obtain your consent if necessary.\n' +
      '4.4 Public Disclosure\n' +
      'We will only publicly disclose your personal data with your consent or when required by law.\n' +
      '\n' +
      '5. Managing Your Personal Data\n' +
      'You have the right to access, correct, or delete your personal data, and may withdraw your consent for data processing at any time. To exercise these rights, please contact our customer service channels.\n' +
      '\n' +
      '6. Cross-Border Data Transfers\n' +
      'As a global company, your data may be processed in different countries or regions. We ensure that data is processed in accordance with this Statement and applicable laws.\n' +
      '\n' +
      '7. Updates to This Statement\n' +
      'We reserve the right to update this Statement at any time. For major changes, we will notify you via a website notice or direct communication.\n' +
      '\n' +
      '8. Contact Us\n' +
      'If you have any questions or suggestions, please contact us via online customer service or email at service@petheylife.com. We will respond to your request within the time frame specified by law.\n' +
      '\n' +
      'Copyright Statement\n' +
      'Copyright © The Website. All rights reserved.Last Updated: October 23, 2024\n',
    'I have read and agree': 'I have read and agree',
    'and': 'and',
  },

  // 注册页
  reg: {
    'Invalid email verification code': 'Invalid email verification code. ',
    'Login': 'Login',
    'Register': 'Register',
    'Your Account': 'Your Account',
    'Email': 'Email',
    'Please confirm your password': 'Please confirm your password',
    'Name': 'Name',
    'Contact number': 'Contact number',
    'Dog Tag ID': 'Dog Tag ID',
    'Please enter your name': 'Please enter your name',
    'Please enter your phone number': 'Please enter your phone number',
    'Please enter your dog tagId': 'Please enter your Dog Tag ID',
    'Email address not valid.': 'Email address not valid.',
    'Password must not less then 6 characters.': 'Password must not less then 6 characters.',
    'Password mismatch.': 'Password mismatch.',
    'Please input dog tag Id.': 'Please input Dog Tag ID.',
    'Registered successfully': 'Registered successfully',
    'Register your details to': 'Register your details to activate your pet’s tag. This helps us ensure that your pet can always find its way back to you if it gets lost.'
  },

  // 个人中心页
  person_center: {
    'Pet Profile': 'Pet Profile',
    'My Account': 'My Account',
    'Setting': 'Setting',
    'Are you sure you want to logout?': 'Are you sure you want to logout?',
  },

  // 宠物列表页
  person_list: {
    'Add a New Profile': 'Add a New Profile',
    'Fetch list failed.': 'Fetch list failed.',
    'unbind title': 'Unbind',
    'unbind info': 'Are you sure you want to unbind? ',
  },

  // 宠物详情页
  checked_info: {
    'Please contact my owner to help find me': 'Please contact my owner to help find me'
  },

  // 编辑宠物信息页
  edit_info: {
    'Click to choose profile picture': 'Click to choose profile picture',
    'Nickname': 'Nickname',
    'Required': 'Required',
    'Optional': 'Optional',
    'Breed': 'Breed',
    'Birth': 'Birth',
    'Size': 'Size',
    'Special Need': 'Special Need',
    'Please upload image': 'Please upload image',
    'The image cannot large than 10MB': 'The image cannot large than 10MB',
    'Upload image error': 'Upload image error',
    'Please enter nickname': 'Please enter nickname',
    'Please enter Dog Tag ID': 'Please enter Dog Tag ID'
  },

  // 编辑个人信息页
  edit_profile: {
    'Pet Owner Profile': 'Pet Owner Profile',
    'Contact number': 'Contact number',
    'Please enter your nickname': 'Please enter your nickname',
    'Please enter your contact number': 'Please enter your contact number'
  },

  // 修改密码页
  update_pwd: {
    'change': 'change',
    'Password': 'Password',
    'Please enter your old password': 'Please enter your old password',
    'Please enter your new password': 'Please enter your new password',
    'Please confirm your new password': 'Please confirm your new password',
    'Please enter your current password': 'Please enter your current password',
    'Please enter your password': 'Please enter your password',
    'Change successfully': 'Change successfully',
  },

  // 忘记密码页
  forget_pwd: {
    'Forget': 'Forget',
    'Change Password': 'Change Password'
  },
}



// WEBPACK FOOTER //
// ./src/i18n/en-US.js